import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { GestaoPcaService } from './gestao-pca-service';
import { UsuarioService } from './usuario-service';
import { UtilService } from './util-service';
import { HttpHeaders } from '@angular/common/http';
import { saveAs } from 'file-saver';

/*
  Generated class for the CertificadoService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class CertificadoService {

  constructor(http: HttpClient,
    private gestaoPcaService: GestaoPcaService,
    private usuarioService: UsuarioService,
    private utilService: UtilService) {
  }

  public obterCertificado(): Observable<any> {
    let urlObtencaoDados: string = "certificado/obterCertificado?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public obterPreCertificado(): Observable<any> {
    let urlObtencaoDados: string = "certificado/obterPreCertificado?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  //Salvar edição de dados gerais
  public gerarCertificado(dadosGerais, id): Observable<any> {
    let urlObtencaoDados: string = "dadosgerais/salvarDados/" + id;
    return this.utilService.postJSON(urlObtencaoDados, dadosGerais);
  }

  public salvarCertificado(preCertificado): Observable<any> {
    let urlObtencaoDados: string = "certificado/salvarPreCertificado";
    return this.utilService.postJSON(urlObtencaoDados, preCertificado);
  }

  public limparCertificado(): Observable<any> {
    let urlObtencaoDados: string = "certificado/limparCertificado?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public finalizarCertificado(certificado): Observable<any> {
    let urlObtencaoDados: string = "certificado/finalizarCertificado";
    return this.utilService.postJSON(urlObtencaoDados, certificado);
  }

  public baixarCertificado(idPca) {
    var headers = new HttpHeaders();
    headers.append('responseType', 'arraybuffer');
    this.utilService.getJSON("certificado/downloadCertificadoPDF/" + idPca)
      .subscribe(data => {

        if (data) {
          let contentType = "data:" + data.mimeType + ";base64";

          let byteCharacters = atob(data.decodedFile);

          let byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);
          let file = new Blob([byteArray], { type: contentType });
          saveAs(file, data.filename);
        }
      },
        error => console.log("Ocorreu um erro ao fazer o download do certificado: " + error));
  }

  public buscarProcesso(): Observable<any>  {
    let urlObtencaoDados: string = "pca/buscarProcessoCertificado?idPca=" + this.gestaoPcaService.getPCA().id + "&idUsuario=" + this.usuarioService.obterDadosUsuario().usr.dadosUsuario[0].idUsuario;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public autuarCertificado(json): Observable<any> {
    console.log(this.usuarioService.obterDadosUsuario());
    let urlObtencaoDados: string = "pca/autuarPca?idPca=" + this.gestaoPcaService.getPCA().id + "&idUsuario="  + this.usuarioService.obterDadosUsuario().usr.dadosUsuario[0].idUsuario;
    return this.utilService.postJSON(urlObtencaoDados, json);
  }

}



// WEBPACK FOOTER //
// ./src/providers/certificado-service.ts